// extracted by mini-css-extract-plugin
export default {"root":"root__27Nhn","overlay":"overlay__6w7SS","sidebar":"sidebar__1JJEw","dragHandle":"dragHandle__WuXlt"};
    if(module.hot) {
      // 1764953358164
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  